module.exports = __webpack_public_path__ + "img/record_img_2.db57d576.png";